import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import line5 from '../../assets/images/svg/line-5.svg'
import vector13 from '../../assets/images/svg/vector-13.svg'
import union1 from '../../assets/images/svg/union-1.svg'
import vector3 from '../../assets/images/svg/vector-3.svg'
import vector from '../../assets/images/svg/vector-1.svg'
import line3 from '../../assets/images/svg/line-5-3.svg'
import vector4 from '../../assets/images/svg/vector-4.svg'
import rectangle5 from '../../assets/images/png/rectangle-5-4.png'
import agnleDownSmall from '../../assets/images/svg/angle-down-small-4.svg'
import moreCircle from '../../assets/images/svg/more-circle.svg'
import metaStep1 from "../../assets/images/svg/meta-step1.svg";
import metaStep2 from "../../assets/images/svg/meta-step2.svg";
import metaStep3 from "../../assets/images/svg/meta-step3.svg";
import line53 from '../../assets/images/svg/line-5-3.svg'
import plusIcon from '../../assets/images/png/plus.png'
import lockIcon from '../../assets/images/png/lock.png'
import tickIcon from '../../assets/images/svg/tick.svg'
import cancelIcon from '../../assets/images/svg/cancel.svg'
import disconnectIcon from '../../assets/images/svg/mab-disconnect.svg'
import mabAdArrow from '../../assets/images/svg/comparrow.svg'
import rightArrow from '../../assets/images/svg/Right-arrow.svg'
import CollapsibleSections from '../../components/collapsible-sections/collapsible-sections';
import { useGetMetaAdsAuthStatusQuery, useMetaAdsLoginMutation, useGetMetaAdsPagesQuery, useGetMetaAdsInstagramAccountsQuery, useGetMetaAdsAdAccountsQuery, useGetMetaAdsPixelsQuery, useGetMetaAdsSavedPixelsQuery, useMetaAdsRefreshMutation, useMetaAdsDisconnectMutation, useCreateMetaAdsPixelMutation, useUpdateMetaAdsPixelMutation, useDeleteMetaAdsPixelMutation } from '../../components/apis/metaAdsApi';
import { ROUTES } from "../../components/consts/routes.consts";

export default function MetaAdsBuilder() {
  const [activeTab, setActiveTab] = useState("artists");
  const [showFullGuide, setShowFullGuide] = useState(false);
  const [showPixelInputs, setShowPixelInputs] = useState(false);
  const [showNewPixelForm, setShowNewPixelForm] = useState(false);
  const [newPixelData, setNewPixelData] = useState({
    name: '',
    type: '',
    id: '',
    capiToken: ''
  });
  const [tracksTabState, setTracksTabState] = useState("tracks");
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [pixelOptionsOpenIndex, setPixelOptionsOpenIndex] = useState<number | null>(null);
  const [editablePixelIndex, setEditablePixelIndex] = useState<number | null>(null);
  const [editingPixelData, setEditingPixelData] = useState<{
    name: string;
    type: string;
    id: string;
    capiToken: string;
    pixelId: string;
  } | null>(null);
  const [selectedPage, setSelectedPage] = useState<{
    id: string;
    name: string;
    category: string;
    picture?: { data?: { url?: string } };
  } | null>(null);
  const [isPageDropdownOpen, setIsPageDropdownOpen] = useState(false);
  const [isRetryingInstagram, setIsRetryingInstagram] = useState(false);
  const [instagramRetryCount, setInstagramRetryCount] = useState(0);
  const MAX_INSTAGRAM_RETRIES = 3;
  const [selectedInstagramAccount, setSelectedInstagramAccount] = useState<{ id: string; name: string; profile_picture_url?: string } | null>(null);
  const [isInstagramDropdownOpen, setIsInstagramDropdownOpen] = useState(false);
  const [selectedAdAccount, setSelectedAdAccount] = useState<{ id: string; name: string; account_id?: string } | null>(null);
  const [isLoadingFromStorage, setIsLoadingFromStorage] = useState(true);
  const [isAdAccountDropdownOpen, setIsAdAccountDropdownOpen] = useState(false);
  const [selectedPixel, setSelectedPixel] = useState<{ id: string; name: string } | null>(null);
  const [isPixelDropdownOpen, setIsPixelDropdownOpen] = useState(false);
  const [openHowItWorks, setOpenHowItWorks] = useState(false);
  const SESSION_KEY = "metaAdsSelections";
  const PIXEL_STORAGE_KEY = "metaAdsSelectedPixel";
  const PAGE_STORAGE_KEY = "metaAdsSelectedPage";
  const INSTAGRAM_STORAGE_KEY = "metaAdsSelectedInstagram";
  const AD_ACCOUNT_STORAGE_KEY = "metaAdsSelectedAdAccount";

  const { data: authStatusData, isLoading: isAuthStatusLoading, refetch: refetchAuthStatus } = useGetMetaAdsAuthStatusQuery();
  const [metaAdsLogin, { isLoading: isLoginLoading }] = useMetaAdsLoginMutation();
  const popupRef = useRef<Window | null>(null);
  const [metaAdsRefresh, { isLoading: isRefreshLoading }] = useMetaAdsRefreshMutation();
  const [metaAdsDisconnect, { isLoading: isDisconnecting }] = useMetaAdsDisconnectMutation();
  const [createMetaAdsPixel, { isLoading: isCreatingPixel }] = useCreateMetaAdsPixelMutation();
  const [updateMetaAdsPixel, { isLoading: isUpdatingPixel }] = useUpdateMetaAdsPixelMutation();
  const [deleteMetaAdsPixel, { isLoading: isDeletingPixel }] = useDeleteMetaAdsPixelMutation();

  const isFacebookConnected = authStatusData?.connected ?? false;

  const { data: pagesData, isLoading: isPagesLoading, refetch: refetchPages } = useGetMetaAdsPagesQuery(undefined, {
    skip: !isFacebookConnected,
  });

  const { data: instagramAccountsData, isLoading: isInstagramAccountsLoading, isError: isInstagramAccountsError, refetch: refetchInstagramAccounts } = useGetMetaAdsInstagramAccountsQuery(
    { pageId: selectedPage?.id || "" },
    {
      skip: !isFacebookConnected || !selectedPage?.id,
    },
  );

  const { data: adAccountsData, isLoading: isAdAccountsLoading, refetch: refetchAdAccounts } = useGetMetaAdsAdAccountsQuery(
    { pageId: selectedPage?.id || '' },
    {
      skip: !isFacebookConnected || !selectedPage?.id,
    }
  );

  const { data: pixelsData, isLoading: isPixelsLoading, refetch: refetchPixels } = useGetMetaAdsPixelsQuery(
    { adAccountId: selectedAdAccount?.id || '' },
    {
      skip: !isFacebookConnected || !selectedAdAccount?.id,
    }
  );

  const { data: savedPixelsData, isLoading: isSavedPixelsLoading, refetch: refetchSavedPixels } = useGetMetaAdsSavedPixelsQuery(undefined, {
    skip: !isFacebookConnected,
  });

  const navigate = useNavigate();
  const persistSelections = (
    page: { name?: string; id?: string; picture?: { data?: { url?: string } } } | null,
    adAccount: { name?: string; account_id?: string; id?: string } | null,
    instagram: { name?: string; id?: string; profile_picture_url?: string } | null,
    pixel: { id?: string; name?: string } | null
  ) => {
    try {
      const payload = {
        page: page
          ? {
            name: page.name ?? "",
            id: page.id ?? "",
            image: page.picture?.data?.url ?? null,
          }
          : null,
        adAccount: adAccount
          ? {
            name: adAccount.name ?? "",
            // Use id (which has "act_" prefix) first, fallback to account_id
            id: adAccount.id || adAccount.account_id || "",
          }
          : null,
        instagram: instagram
          ? {
            name: instagram.name ?? "",
            id: instagram.id ?? "",
            image: instagram.profile_picture_url ?? null,
          }
          : null,
        pixel: pixel
          ? {
            name: pixel.name ?? "",
            id: pixel.id ?? "",
          }
          : null,
      };
      // Save to sessionStorage for navigation (now includes images)
      const simplifiedPayload = {
        page: payload.page ? { id: payload.page.id, name: payload.page.name, image: payload.page.image } : null,
        adAccount: payload.adAccount ? { id: payload.adAccount.id, name: payload.adAccount.name } : null,
        instagram: payload.instagram ? { id: payload.instagram.id, name: payload.instagram.name, image: payload.instagram.image } : null,
        pixel: payload.pixel ? { id: payload.pixel.id, name: payload.pixel.name } : null,
      };
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(simplifiedPayload));

      // Save full data with images to localStorage
      localStorage.setItem("metaAdsAccountData", JSON.stringify(payload));
    } catch (e) {
      console.error("Failed to persist meta ads selections", e);
    }
  };


  // Auto-select first available options once data loads (only when not loading to avoid selecting stale cached data)
  useEffect(() => {
    if (!selectedPage && !isPagesLoading && pagesData?.pages?.length) {
      setSelectedPage(pagesData.pages[0]);
    }
  }, [pagesData, selectedPage, isPagesLoading]);


  // Load Ad Account from localStorage on component mount (MUST RUN FIRST before auto-select)
  useEffect(() => {
    try {
      const raw = localStorage.getItem(AD_ACCOUNT_STORAGE_KEY);
      if (raw && !selectedAdAccount) {
        const parsed = JSON.parse(raw);
        setSelectedAdAccount(parsed);
      }
    } catch (e) {
      console.error("Failed to load ad account from storage", e);
    } finally {
      setIsLoadingFromStorage(false); // Signal that loading is complete
    }
  }, []);

  // Load pixel from localStorage for current ad account on component mount
  useEffect(() => {
    if (!selectedAdAccount?.id) return;

    try {
      const raw = localStorage.getItem(PIXEL_STORAGE_KEY);
      if (raw && !selectedPixel) {
        const parsed = JSON.parse(raw);
        // Only load pixel if it belongs to the current ad account
        if (parsed.pixel && parsed.adAccountId === selectedAdAccount.id) {
          setSelectedPixel(parsed.pixel);
        }
      }
    } catch (e) {
      console.error("Failed to load pixel from storage", e);
    }
  }, [selectedAdAccount?.id]);

  // Load Facebook Page from localStorage on component mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem(PAGE_STORAGE_KEY);
      if (raw && !selectedPage) {
        const parsed = JSON.parse(raw);
        setSelectedPage(parsed);
      }
    } catch (e) {
      console.error("Failed to load page from storage", e);
    }
  }, []);

  // Load Instagram Account from localStorage on component mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem(INSTAGRAM_STORAGE_KEY);
      if (raw && !selectedInstagramAccount) {
        const parsed = JSON.parse(raw);
        setSelectedInstagramAccount(parsed);
      }
    } catch (e) {
      console.error("Failed to load Instagram from storage", e);
    }
  }, []);

  // Note: No auto-selection - all dropdowns show "Select an account" by default
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const connected = params.get("connected");
    const error = params.get("error");

    if (connected === "true" || error === "access_denied") {
      console.log("CONNECTED =>", connected);

      // Close popup window
      window.close();

      // OPTIONAL: notify opener page
      if (window.opener) {
        window.opener.postMessage(
          { type: "FB_REFRESH_DONE", connected },
          "*"
        );
      }
    }
  }, []);

  // Reset selected pixel when ad account changes and load new pixel if exists
  useEffect(() => {
    if (!selectedAdAccount?.id) return;

    // Reset pixel first
    setSelectedPixel(null);

    // Try to load saved pixel for new ad account
    try {
      const raw = localStorage.getItem(PIXEL_STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        // Only load pixel if it belongs to the new ad account
        if (parsed.pixel && parsed.adAccountId === selectedAdAccount.id) {
          setSelectedPixel(parsed.pixel);
        }
      }
    } catch (e) {
      console.error("Failed to load pixel from storage", e);
    }
  }, [selectedAdAccount?.id]);

  // Refetch pixels when ad account changes
  // Note: Cache invalidation handles this automatically when the query params change
  // No manual refetch needed since RTK Query will refetch when selectedAdAccount changes

  // Update pixel ID field when a pixel is selected from dropdown (don't update type)
  useEffect(() => {
    if (selectedPixel) {
      setNewPixelData(prev => ({
        ...prev,
        id: selectedPixel.id || prev.id
      }));
    }
  }, [selectedPixel]);

  // Persist selections to session storage
  useEffect(() => {
    persistSelections(selectedPage, selectedAdAccount, selectedInstagramAccount, selectedPixel);
  }, [selectedPage, selectedAdAccount, selectedInstagramAccount, selectedPixel]);

  // Save selected pixel to localStorage when it changes (for persistence across refreshes)
  useEffect(() => {
    if (!selectedAdAccount?.id) return;

    try {
      if (selectedPixel) {
        // Save pixel with ad account association
        localStorage.setItem(PIXEL_STORAGE_KEY, JSON.stringify({
          pixel: selectedPixel,
          adAccountId: selectedAdAccount.id
        }));
      } else {
        // Check if there's a saved pixel for this ad account and remove it
        const raw = localStorage.getItem(PIXEL_STORAGE_KEY);
        if (raw) {
          const parsed = JSON.parse(raw);
          if (parsed.adAccountId === selectedAdAccount.id) {
            localStorage.removeItem(PIXEL_STORAGE_KEY);
          }
        }
      }
    } catch (e) {
      console.error("Failed to save pixel to storage", e);
    }
  }, [selectedPixel, selectedAdAccount?.id]);

  // Save selected Facebook Page to localStorage when it changes (for persistence across refreshes)
  useEffect(() => {
    try {
      if (selectedPage) {
        localStorage.setItem(PAGE_STORAGE_KEY, JSON.stringify(selectedPage));
      } else {
        localStorage.removeItem(PAGE_STORAGE_KEY);
      }
    } catch (e) {
      console.error("Failed to save page to storage", e);
    }
  }, [selectedPage]);

  // Save selected Instagram Account to localStorage when it changes (for persistence across refreshes)
  useEffect(() => {
    try {
      if (selectedInstagramAccount) {
        localStorage.setItem(INSTAGRAM_STORAGE_KEY, JSON.stringify(selectedInstagramAccount));
      } else {
        localStorage.removeItem(INSTAGRAM_STORAGE_KEY);
      }
    } catch (e) {
      console.error("Failed to save Instagram to storage", e);
    }
  }, [selectedInstagramAccount]);

  // Save selected Ad Account to localStorage when it changes (for persistence across refreshes)
  useEffect(() => {
    try {
      if (selectedAdAccount) {
        localStorage.setItem(AD_ACCOUNT_STORAGE_KEY, JSON.stringify(selectedAdAccount));
      } else {
        localStorage.removeItem(AD_ACCOUNT_STORAGE_KEY);
      }
    } catch (e) {
      console.error("Failed to save ad account to storage", e);
    }
  }, [selectedAdAccount]);

  // Reset openHowItWorks after it's been processed
  useEffect(() => {
    if (openHowItWorks) {
      const timer = setTimeout(() => {
        setOpenHowItWorks(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [openHowItWorks]);

  // Auto-retry Instagram API when it fails
  useEffect(() => {
    if (isInstagramAccountsError && isFacebookConnected && instagramRetryCount < MAX_INSTAGRAM_RETRIES) {
      const timer = setTimeout(() => {
        console.log(`Retrying Instagram API... Attempt ${instagramRetryCount + 1} of ${MAX_INSTAGRAM_RETRIES}`);
        setIsRetryingInstagram(true);
        refetchInstagramAccounts().then(() => {
          setInstagramRetryCount(prev => prev + 1);
        }).finally(() => {
          setIsRetryingInstagram(false);
        });
      }, 2000); // Retry after 2 seconds

      return () => clearTimeout(timer);
    }
  }, [isInstagramAccountsError, isFacebookConnected, instagramRetryCount, refetchInstagramAccounts]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (isPageDropdownOpen && !target.closest('.facebook-page-dropdown')) {
        setIsPageDropdownOpen(false);
      }
      if (isInstagramDropdownOpen && !target.closest('.instagram-account-dropdown')) {
        setIsInstagramDropdownOpen(false);
      }
      if (isAdAccountDropdownOpen && !target.closest('.ad-account-dropdown')) {
        setIsAdAccountDropdownOpen(false);
      }
      if (isPixelDropdownOpen && !target.closest('.pixel-dropdown')) {
        setIsPixelDropdownOpen(false);
      }
    };

    if (isPageDropdownOpen || isInstagramDropdownOpen || isAdAccountDropdownOpen || isPixelDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [isPageDropdownOpen, isInstagramDropdownOpen, isAdAccountDropdownOpen, isPixelDropdownOpen]);

  const handleConnectFacebook = async () => {
    setIsRedirecting(true);

    try {
      const response = await metaAdsLogin().unwrap();
      const authURL = response?.authURL;

      if (!authURL) {
        setIsRedirecting(false);
        setIsPopupOpen(false);
        toast.error("Failed to initiate Facebook login.");
        return;
      }

      // Calculate center position for popup
      const width = 600;
      const height = 750;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      // Open popup centered on screen
      const popup = window.open(
        authURL,
        "metaAdsAuthPopup",
        `width=${width},height=${height},left=${left},top=${top}`
      );
      if (popup) {
        setIsPopupOpen(true);
      }
      // Listen for popup message
      const handleMessage = async (event: any) => {
        if (event.data?.type === "FB_REFRESH_DONE") {
          const isConnected = event.data?.connected === true || event.data?.connected === "true";
          if (isConnected) {
            // Clear saved selections from localStorage
            localStorage.removeItem(PIXEL_STORAGE_KEY);
            localStorage.removeItem(PAGE_STORAGE_KEY);
            localStorage.removeItem(INSTAGRAM_STORAGE_KEY);
            localStorage.removeItem(AD_ACCOUNT_STORAGE_KEY);

            toast.success("Facebook connected successfully!");

            // Instant page reload (user won't notice much)
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }

          popup?.close();
          window.removeEventListener("message", handleMessage);
          setIsPopupOpen(false);
          setIsRedirecting(false);
        }
      };

      window.addEventListener("message", handleMessage);

    } catch (err) {
      console.error("Facebook login error:", err);
      setIsRedirecting(false);
      setIsPopupOpen(false);
      toast.error("Failed to connect Facebook");
    }
  };
  const handleRefreshFacebookAccess = async () => {
    setIsRedirecting(true);

    try {
      await metaAdsRefresh().unwrap();
      console.log("Refresh API called before popup.");

      const response = await metaAdsLogin().unwrap();
      const authURL = response?.authURL;

      if (!authURL) {
        toast.error("Failed to start Facebook login flow.");
        setIsRedirecting(false);
        setIsPopupOpen(false);
        return;
      }

      // Calculate center position for popup
      const width = 600;
      const height = 750;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      // Open popup centered on screen
      const popup = window.open(
        authURL,
        "metaAdsAuthPopup",
        `width=${width},height=${height},left=${left},top=${top}`
      );
      if (popup) {
        setIsPopupOpen(true);
      }


      const handleMessage = (event: any) => {
        if (event.data?.type === "FB_REFRESH_DONE") {
          console.log("CONNECTED:", event.data.connected);
          const isConnected = event.data?.connected === true || event.data?.connected === "true";
          if (isConnected) {
            // Clear saved selections from localStorage
            localStorage.removeItem(PIXEL_STORAGE_KEY);
            localStorage.removeItem(PAGE_STORAGE_KEY);
            localStorage.removeItem(INSTAGRAM_STORAGE_KEY);
            localStorage.removeItem(AD_ACCOUNT_STORAGE_KEY);

            toast.success("Facebook access refreshed successfully!");

            // Refetch all data silently
            Promise.all([
              refetchAuthStatus(),
              refetchPages(),
              refetchInstagramAccounts(),
              refetchAdAccounts(),
              refetchSavedPixels(),
            ]).then(() => {
              console.log("All data refetched successfully after refresh");
            }).catch((error) => {
              console.error("Error refetching data:", error);
              // Fallback to page reload if refetch fails
              window.location.reload();
            });

          }
          popup?.close();

          // Remove listener
          window.removeEventListener("message", handleMessage);
          setIsPopupOpen(false);
          setIsRedirecting(false);
        }
      };

      window.addEventListener("message", handleMessage);

    } catch (e) {
      toast.error("Failed to refresh access");
      setIsRedirecting(false);
      setIsPopupOpen(false);
    }
  };



  // Show loading until the popup opens, then hide it while the popup is active.
  // Also cover disconnect calls to mirror refresh/login behavior.
  const showLoading = (isLoginLoading && !isPopupOpen) || isDisconnecting;

  // New Campaign button should only show if:
  // 1. Facebook is connected
  // 2. Facebook page is selected
  // 3. Instagram account is selected
  // 4. Ad account is selected
  // 5. Pixel is selected
  const showNewCampaignCTA = isFacebookConnected &&
    selectedPage !== null &&
    selectedInstagramAccount !== null &&
    selectedAdAccount !== null &&
    selectedPixel !== null;

  const handleStartNewCampaign = () => {
    navigate(ROUTES.META_NEW_COMPAING);
  };

  const [pixelData, setPixelData] = useState([
    {
      name: "Pitchplaylists",
      type: "Facebook Ads [Pixel + CAPI Token]",
      id: "123456789012345",
      capiToken: "",
    },
  ]);

  const handlePixelFieldChange = (index: number, field: string, value: string) => {
    setPixelData(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: value
      };
      return updated;
    });
  };

  const setupSteps = [
    {
      number: 1,
      title: "Connect your Instagram account to your Facebook page",
      content: {
        heading: "Link your Instagram with your Facebook Page",
        description:
          "On your phone, open Instagram → go to Settings → Account → Sharing to other apps → Facebook.\nLog in to Facebook, select the Page you want to connect and confirm. After saving, your Instagram profile will be linked to that Facebook Page and can be used in Meta Ads.",
      },
    },
    {
      number: 2,
      title: "Set up your Facebook Business Portfolio and verify your email",
      content: {
        heading: "Open Facebook Business Manager,",
        description:
          "Сreate or select your Business and follow the prompts to complete the setup. Check your inbox and click the verification link from Facebook to confirm your business email address.",
      },
    },
    {
      number: 3,
      title: "Set up your Facebook Ad Account",
      content: {
        heading: "In Business Manager → Settings → Ad Accounts,",
        description:
          "Сreate a new ad account or connect an existing one.\nChoose your time zone, currency, and payment method, then save your settings so the account is ready for campaigns.",
      },
    },
    {
      number: 4,
      title: "Set up your Facebook Pixel",
      content: {
        heading: "Go to Events Manager",
        description:
          'In Facebook, click "Connect data source" → Web → Facebook Pixel". Name your Pixel, connect it to your website domain, and follow the guided steps to install the Pixel code or use an integration (e.g. via your CMS).',
      },
    },
    {
      number: 5,
      title: "Connect your Instagram account to your Facebook page",
      content: {
        heading: "In your PitchPlaylists",
        description:
          "Open the Pixel / Tracking section. Paste your Facebook Pixel ID into the dedicated field and save the changes, so all traffic and conversions from your campaigns are tracked correctly.",
        hasImage: true,
      },
    },
  ];


  const handleAddNewPixel = () => {
    // Don't pre-populate type field - let placeholder show
    // Populate ID from selected pixel if available
    if (selectedPixel) {
      setNewPixelData(prev => ({
        ...prev,
        id: selectedPixel.id || prev.id
      }));
    }
    // Directly show the new pixel form
    setShowNewPixelForm(true);
  };

  const handleSaveNewPixel = async () => {
    // Validate required fields (CAPI token is optional, type will use default if empty)
    if (!newPixelData.name.trim() || !newPixelData.id.trim()) {
      toast.error('Pixel name and ID are required. Please fill in all required fields before saving.');
      return;
    }

    // Validate ad account is selected
    if (!selectedAdAccount?.id) {
      toast.error('Please select an ad account first.');
      return;
    }

    try {
      // Call API to create pixel with default type if empty
      await createMetaAdsPixel({
        name: newPixelData.name.trim(),
        type: newPixelData.type.trim() || 'Facebook Ads [Pixel + CAPI Token]',
        pixelId: newPixelData.id.trim(),
        capiToken: newPixelData.capiToken?.trim() === '' ? "" : newPixelData.capiToken?.trim() || "",
        adAccountId: selectedAdAccount.id,
      }).unwrap();

      // Show success message
      toast.success('Pixel saved successfully!');

      // Cache invalidation automatically refetches saved pixels
      // via createMetaAdsPixel mutation's invalidatesTags

      // Reset form and hide it
      setNewPixelData({
        name: '',
        type: '',
        id: '',
        capiToken: ''
      });
      setShowNewPixelForm(false);
    } catch (error: any) {
      console.error('Error saving pixel:', error);
      toast.error(error?.data?.msg || error?.message || 'Failed to save pixel. Please try again.');
    }
  };

  const handleCancelNewPixel = () => {
    // Don't allow canceling while saving
    if (isCreatingPixel) {
      return;
    }
    // Reset form and hide it, keep pixel inputs visible
    setNewPixelData({
      name: '',
      type: '',
      id: '',
      capiToken: ''
    });
    setShowNewPixelForm(false);
  };

  const handleDisconnectProfile = async () => {
    try {
      await metaAdsDisconnect().unwrap();
      // Clear saved selections from localStorage
      localStorage.removeItem(PIXEL_STORAGE_KEY);
      localStorage.removeItem(PAGE_STORAGE_KEY);
      localStorage.removeItem(INSTAGRAM_STORAGE_KEY);
      localStorage.removeItem(AD_ACCOUNT_STORAGE_KEY);
      toast.success("Disconnected, please try refreshing the page");
      // Cache invalidation will automatically refetch via metaAdsDisconnect mutation
    } catch (error) {
      console.error("Disconnect error:", error);
      toast.error("Failed to disconnect. Please try again.");
    }
  };

  const handleNewPixelInputChange = (field: string, value: string) => {
    setNewPixelData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  useEffect(() => {
    if (pixelOptionsOpenIndex === null) return;
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const menuEl = target.closest('[data-pixel-menu-index]');
      if (!menuEl) {
        setPixelOptionsOpenIndex(null);
        return;
      }
      const indexAttr = menuEl.getAttribute('data-pixel-menu-index');
      if (indexAttr === null || Number(indexAttr) !== pixelOptionsOpenIndex) {
        setPixelOptionsOpenIndex(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [pixelOptionsOpenIndex]);

  const handleEditPixel = (index: number) => {
    const pixel = savedPixelsData?.pixels?.[index];
    if (pixel) {
      const pixelId = (pixel as any)._id || pixel.id;
      setEditingPixelData({
        name: pixel.name || '',
        type: pixel.type || 'Facebook Ads [Pixel + CAPI Token]',
        id: pixel.id || pixel.pixelId || '',
        capiToken: (pixel as any).capiToken || '',
        pixelId: pixelId || ''
      });
      setEditablePixelIndex(index);
      setPixelOptionsOpenIndex(null);
    }
  };

  const handleSaveEditPixel = async () => {
    if (!editingPixelData || editablePixelIndex === null) {
      return;
    }

    // Validate required fields (Pixel ID is optional - can be cleared)
    if (!editingPixelData.name.trim() || !editingPixelData.type.trim()) {
      toast.error('Pixel name and type are required.');
      return;
    }

    if (!editingPixelData.pixelId) {
      toast.error('Pixel ID not found');
      return;
    }

    if (!selectedAdAccount?.id) {
      toast.error('Please select an ad account first.');
      return;
    }

    try {
      // Call update API
      await updateMetaAdsPixel({
        pixelId: editingPixelData.pixelId, // This is the database _id (MongoDB ObjectId)
        name: editingPixelData.name.trim(),
        type: editingPixelData.type.trim(),
        capiToken: editingPixelData.capiToken === null ? "" : editingPixelData.capiToken?.trim() === '' ? "" : editingPixelData.capiToken?.trim() || "",
        adAccountId: selectedAdAccount.id,
      }).unwrap();

      // Show success message
      toast.success('Pixel updated successfully!');

      // Cache invalidation automatically refetches saved pixels
      // via updateMetaAdsPixel mutation's invalidatesTags

      // Reset editing state
      setEditablePixelIndex(null);
      setEditingPixelData(null);
    } catch (error: any) {
      console.error('Error updating pixel:', error);
      toast.error(error?.data?.msg || error?.message || 'Failed to update pixel. Please try again.');
    }
  };

  const handleCancelEditPixel = () => {
    setEditablePixelIndex(null);
    setEditingPixelData(null);
  };

  const handleEditPixelFieldChange = (field: string, value: string) => {
    if (editingPixelData) {
      setEditingPixelData(prev => ({
        ...prev!,
        [field]: value
      }));
    }
  };

  const handleRemovePixel = async (index: number) => {
    // Get the pixel from saved pixels list
    const pixel = savedPixelsData?.pixels?.[index];
    if (!pixel) {
      toast.error('Pixel not found');
      setPixelOptionsOpenIndex(null);
      return;
    }

    // Get pixel ID (could be _id or id)
    const pixelId = (pixel as any)._id || pixel.id;
    if (!pixelId) {
      toast.error('Pixel ID not found');
      setPixelOptionsOpenIndex(null);
      return;
    }

    try {
      // Call delete API
      await deleteMetaAdsPixel({ pixelId }).unwrap();

      // Show success message
      toast.success('Pixel deleted successfully');

      // Cache invalidation automatically refetches saved pixels
      // via deleteMetaAdsPixel mutation's invalidatesTags

      // Close the menu
      setPixelOptionsOpenIndex(null);
    } catch (error: any) {
      console.error('Error deleting pixel:', error);
      toast.error(error?.data?.msg || error?.message || 'Failed to delete pixel. Please try again.');
      setPixelOptionsOpenIndex(null);
    }
  };


  // Show loading until auth status is determined
  if (isAuthStatusLoading) {
    return (
      <div className="fixed inset-0 z-[9999] min-h-screen flex items-center justify-center backdrop-blur-[20px] bg-[rgba(0,0,0,0.5)]">
        <CircularProgress size={50} style={{ color: "#ffffff" }} />
      </div>
    );
  }

  return (
    <>
      {showLoading && (
        <div className="fixed inset-0 z-[9999] min-h-screen flex items-center justify-center backdrop-blur-[20px] bg-[rgba(0,0,0,0.5)]">
          <CircularProgress size={50} style={{ color: "#ffffff" }} />
        </div>
      )}
      <div className="sidebar-wrapper pt-10 pb-10 2xl:pl-8 xl:pl-6 md:flex-1 md:w-auto w-full xl:inline-block xl:w-[calc(100%-320px)] xl:align-top">
        <div className="sidebar-wrapper-content flex md:flex-row flex-col 2xl:gap-8 xl:gap-6 md:gap-3 gap-6">
          <div className="flex-1">

            <div className="flex flex-col w-full items-start gap-16">
              <div className="flex flex-col items-start gap-[15px] relative self-stretch w-full flex-[0_0_auto]">
                <div className="flex items-end gap-2.5 relative self-stretch w-full flex-[0_0_auto]">
                  <div className="flex flex-col w-full lg:w-3/4 items-start gap-[30px] relative">
                    <h1 className="relative w-full mt-[-1.00px] font-h-1 font-[number:var(--h-1-font-weight)] bg-black text-white text-[length:var(--h-1-font-size)] tracking-[var(--h-1-letter-spacing)] leading-[var(--h-1-line-height)] [font-style:var(--h-1-font-style)]">
                      Meta Ads Builder
                    </h1>

                    {/* <div className="inline-flex h-[60px] items-center p-1 relative rounded-[999px] bg-[linear-gradient(345deg,rgba(88,242,169,1)_0%,rgba(28,57,65,1)_100%)]">
                    <button
                      className={`inline-flex items-center px-5 py-1 relative self-stretch flex-[0_0_auto] rounded-[999px] ${activeTab === "artists" ? "bg-white" : ""
                        }`}
                      onClick={() => setActiveTab("artists")}
                      aria-pressed={activeTab === "artists"}
                    >
                      <span className={`relative flex items-center justify-center w-fit [font-family:'Poppins',Helvetica] font-medium text-xl tracking-[0] leading-[normal] ${activeTab === "artists" ? "text-[#020202]" : "text-white"
                        }`}>
                        For artists
                      </span>
                    </button>

                    <button
                      className={`inline-flex items-center px-5 py-1 relative self-stretch flex-[0_0_auto] rounded-[999px] overflow-hidden ${activeTab === "curators" ? "bg-white" : ""
                        }`}
                      onClick={() => setActiveTab("curators")}
                      aria-pressed={activeTab === "curators"}
                    >
                      <span className={`relative flex items-center justify-center w-fit [font-family:'Poppins',Helvetica] font-medium text-xl tracking-[0] leading-[normal] ${activeTab === "curators" ? "text-[#020202]" : "text-white"
                        }`}>
                        For curators
                      </span>
                    </button>
                  </div> */}

                    <img
                      className="relative w-[615px] h-px object-cover"
                      alt=""
                      src={line5}
                    />

                    <p className="relative w-fit mr-[-253.00px] [font-family:'Poppins',Helvetica] font-semibold text-white text-[22px] tracking-[0] leading-[26px] whitespace-nowrap">
                      Create Meta ads easily and grow your playlists with a proven music
                      industry method!
                    </p>
                  </div>
                </div>

                <nav className="flex items-center gap-6 pt-4 pb-6 px-0 relative self-stretch w-full flex-[0_0_auto]">
                  <div className="flex h-[30px] w-[141px] items-center gap-1 relative">
                    <span className="relative w-[143px] mr-[-2.00px] [font-family:'Poppins',Helvetica] font-medium text-white text-lg tracking-[0] leading-[23.4px]">
                      New Campaign
                    </span>
                  </div>

                  <img
                    className="relative w-0.5 h-[30px]"
                    alt=""
                    src={vector13}
                  />

                  <div className="flex h-[30px] w-[140px] items-center gap-[33px] relative">
                    <div className="flex w-[177px] items-center gap-[5px] relative mr-[-37.00px]">
                      <button
                        className="relative w-[141px] [font-family:'Poppins',Helvetica] font-medium text-[#4b4f55] text-lg tracking-[0] leading-[23.4px] hover:text-white transition-colors cursor-pointer text-left"
                        onClick={() => navigate(ROUTES.MY_META_CAMPAIGN)}
                      >
                        My Campaigns
                      </button>
                    </div>
                  </div>

                  {/* <img
                  className="relative w-0.5 h-[42px]"
                  alt=""
                  src={vector13}
                />

                <div className="flex w-[120px] items-center gap-1 relative">
                  <span className="relative w-[140px] mt-[-1.00px] mr-[-20.00px] [font-family:'Poppins',Helvetica] font-medium text-[#4b4f55] text-lg tracking-[0] leading-[23.4px]">
                    Smart Link Edit
                  </span>
                </div> */}
                </nav>

                <div className="flex flex-col items-center p-8 lg:p-16 relative self-stretch w-full flex-[0_0_auto] bg-[#0e0e10] rounded-[40px] overflow-hidden border-[none] shadow-[0px_10px_40px_#060c1180] before:content-[''] before:absolute before:inset-0 before:p-0.5 before:rounded-[40px] before:[background:linear-gradient(0deg,rgba(255,255,255,1)_0%,rgba(0,26,255,1)_45%,rgba(27,118,255,1)_100%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none">
                  <div className="absolute top-0 left-0 w-full h-full rounded-[40px] overflow-hidden">
                    <div className="relative top-[-100px] lg:top-[-285px] left-1/2 transform -translate-x-1/2 w-[90vw] lg:w-[1409px] h-[200px] lg:h-[452px] rounded-full blur-[110px] bg-[linear-gradient(270deg,rgba(182,211,255,1)_0%,rgba(0,34,255,1)_53%,rgba(34,255,244,1)_100%)]" />
                  </div>

                  {/* {isFacebookConnected && (
                    <div className="flex items-center justify-end gap-8 relative self-stretch w-full flex-[0_0_auto]">
                      <div className="inline-flex flex-col items-start gap-2 p-[6.4px] relative flex-[0_0_auto] bg-[#878da11a] rounded-[99px]">
                        <div className="inline-flex items-center justify-center gap-5 relative flex-[0_0_auto]">
                          <button
                            className={`inline-flex items-center justify-center gap-2 px-[25.6px] py-[12.8px] relative flex-[0_0_auto] rounded-[99px] ${tracksTabState === "tracks" ? "bg-white" : ""
                              }`}
                            onClick={() => setTracksTabState("tracks")}
                          >
                            <span className={`relative flex items-center justify-center w-fit mt-[-0.80px] [font-family:'Poppins',Helvetica] font-medium text-base tracking-[0] leading-[normal] ${tracksTabState === "tracks" ? "text-black" : "text-white"
                              }`}>
                              Tracks
                            </span>
                          </button>

                          <button
                            className={`inline-flex items-center justify-center gap-2 px-[25.6px] py-[12.8px] relative flex-[0_0_auto] rounded-[99px] ${tracksTabState === "playlists" ? "bg-white" : ""
                              }`}
                            onClick={() => setTracksTabState("playlists")}
                          >
                            <span className={`relative flex items-center justify-center w-fit mt-[-0.80px] [font-family:'Poppins',Helvetica] font-medium text-base tracking-[0] leading-[normal] ${tracksTabState === "playlists" ? "text-black" : "text-white"
                              }`}>
                              Playlists
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  )} */}

                  <div className="flex flex-col w-full items-start justify-center gap-8 relative flex-[0_0_auto]">
                    <section className="flex items-start gap-6 relative self-stretch w-full flex-[0_0_auto]">
                      <div className="w-10 h-10 flex items-center justify-center">
                        <img src={metaStep1} alt="Step 1" className="w-9 h-9" />
                      </div>

                      <div className="gap-6 flex-1 grow flex items-start relative">
                        <div className="flex flex-col items-start gap-6 relative flex-1 grow">
                          <div className="gap-2.5 self-stretch w-full flex-[0_0_auto] flex items-start relative">
                            <div className="inline-flex h-8 items-center gap-2 p-4 relative flex-[0_0_auto] bg-green-500 bg-variable-collection-main-green rounded-[999px] overflow-hidden">
                              <p
                                className="
    [font-family:'Poppins',Helvetica]
    font-semibold
    text-[16px]
    tracking-[0]
    text-black
  "
                              >
                                Active subscription until Feb 29, 2026
                              </p>


                            </div>

                            <div className="inline-flex h-8 items-center gap-2.5 relative flex-[0_0_auto]">
                              <div className="flex flex-col w-6 items-start justify-center gap-2.5 p-0.5 relative">
                                <img
                                  className="relative w-[20.17px] h-[20.17px] mr-[-0.17px]"
                                  alt="Info"
                                  src={union1}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col items-start gap-3 p-6 relative w-full bg-[#878da11a] rounded-[20px] overflow-visible" style={{ zIndex: 1 }}>

                            {/* TOP ROW */}
                            <div className="flex w-full lg:w-3/4 items-center justify-between 
                  max-[900px]:flex-col max-[900px]:items-start max-[900px]:gap-3">

                              <div className="inline-flex items-center gap-3">
                                <img className="w-[26px] h-[26px]" alt="Spotify icon" src={vector3} />
                                <span className="font-normal text-white text-xl leading-[26px] whitespace-nowrap">
                                  Grow my Spotify {tracksTabState === "tracks" ? "track" : "playlist"}
                                </span>
                              </div>

                              <div className="w-6 h-6 opacity-0 overflow-hidden">
                                <img className="absolute w-[74.99%] h-[83.33%]" alt="" src={vector} />
                              </div>
                            </div>

                            {/* DESCRIPTION */}
                            <div className="flex flex-col items-start gap-3 pr-0 w-full">

                              <div className="flex items-start gap-3 w-full">
                                <div className="w-[26px] h-[26px] flex-shrink-0"></div>
                                <p className="flex-1 font-normal text-white text-[14px] leading-[130%] font-[Poppins]
                  max-[900px]:leading-[150%]">
                                  {tracksTabState === "playlists"
                                    ? <>Get fans, listeners and streams for your playlist and the music on it with AI-powered music <br className="max-[900px]:hidden" /> ads on Instagram and Facebook</>
                                    : <>Get more listeners and streams for your track with AI-powered music ads on Instagram <br className="max-[900px]:hidden" /> and Facebook</>
                                  }
                                </p>
                              </div>

                              <div className="flex items-start gap-3 w-full">
                                <div className="w-[26px] h-[26px] flex-shrink-0"></div>
                                <a
                                  href="#how-it-works-section"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setOpenHowItWorks(true);
                                  }}
                                  className="font-normal text-variable-collection-green2 text-base underline cursor-pointer"
                                >
                                  See how it works
                                </a>
                              </div>
                            </div>

                            {/* BACKGROUND (unchanged) */}
                            <div className="absolute top-[-63px] left-[calc(50%-240px)] w-[539px] h-[173px] rounded-[269.5px/86.5px] 
                  blur-[60px] bg-[linear-gradient(180deg,rgba(130,135,152,0)_0%,rgba(130,135,152,0.4)_100%)]" />

                            {/* BUTTON — ONLY MOVES BELOW 900px */}
                            <div className="flex gap-3 absolute top-[35px] right-4
                  max-[900px]:static max-[900px]:mt-4 max-[900px]:self-start" style={{ zIndex: 100 }}>

                              {showNewCampaignCTA ? (
                                <button
                                  className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-white text-[#020202] font-semibold text-base leading-[100%] tracking-[0] [font-family:'Poppins',Helvetica] shadow-[0_8px_24px_rgba(0,0,0,0.35)] hover:translate-y-[-1px] transition-transform"
                                  onClick={handleStartNewCampaign}
                                >
                                  New Campaign
                                  <img src={mabAdArrow} alt="Next" className="w-[29px] h-[29px]" />
                                </button>
                              ) : (
                                <button className="inline-flex h-12 items-center gap-2 px-6 py-6 bg-[#4B4F55] rounded-full">
                                  <img className="w-5 h-5 mb-1.5" alt="Lock" src={lockIcon} />
                                  <span className="font-semibold text-[#A5A7AA] text-[18px] leading-[100%] tracking-[0]">
                                    {isFacebookConnected ? 'Complete Step 2 & 3' : 'Complete Step 2'}
                                  </span>
                                </button>
                              )}
                            </div>

                          </div>

                        </div>
                      </div>
                    </section>

                    <img
                      className="relative w-full h-px object-cover"
                      alt=""
                      src={line3}
                    />

                    <section className="flex flex-col items-start gap-2.5 relative self-stretch w-full flex-[0_0_auto]">
                      <div className="inline-flex items-center gap-6 relative flex-[0_0_auto]">
                        <div className="w-10 h-10 flex items-center justify-center">
                          <img src={metaStep2} alt="Step 2" className="w-9 h-9" />
                        </div>

                        <div className="flex flex-col w-full lg:w-11/12 items-start gap-6 relative">
                          <h2 className="mt-[-1.00px] opacity-[0.88] font-semibold text-[40px] leading-10 relative w-fit [font-family:'Poppins',Helvetica] text-white tracking-[0] whitespace-nowrap">
                            Account Setup
                          </h2>
                        </div>
                      </div>

                      {!isFacebookConnected ? (
                        <div className="flex w-full lg:w-5/6 items-center justify-start pl-[59px] pr-0 pt-8 pb-8 relative flex-[0_0_auto]">
                          <button
                            onClick={handleConnectFacebook}
                            disabled={isLoginLoading}
                            className="inline-flex items-center justify-center gap-2 w-[280px] h-[48px] px-8 py-4 bg-[#FFFFFF] rounded-[999px] hover:opacity-90 transition-opacity cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            <span className="[font-family:'Poppins',Helvetica] font-semibold text-[#000000] text-[18px] tracking-[0] leading-[100%]">
                              {isLoginLoading ? 'Connecting...' : 'Connect with Facebook'}
                            </span>
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="flex w-full lg:w-5/6 items-start gap-[8.4px] pl-[30px] pr-0 py-0 relative flex-[0_0_auto]">
                            <div className="flex flex-col w-[418.25px] items-start gap-[8.4px] pl-[30.8px] pr-0 pt-[11.2px] pb-0 relative">
                              <div className="mb-4">
                                <button
                                  onClick={handleRefreshFacebookAccess}
                                  disabled={isLoginLoading || isRedirecting}
                                  className="flex items-center gap-2 relative w-fit [font-family:'Poppins',Helvetica] font-normal text-variable-collection-white text-sm tracking-[0] leading-[18.2px] whitespace-nowrap hover:opacity-80 transition-opacity cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                                  title="Refresh Facebook Access"
                                >
                                  <span>Refresh Facebook Access</span>
                                  <div className="relative w-5 h-5 flex-shrink-0">
                                    <img
                                      className="absolute w-[66.67%] h-[66.54%] top-[14.23%] left-[14.18%]"
                                      alt="Refresh"
                                      src={vector4}
                                    />
                                  </div>
                                </button>
                              </div>
                              <label
                                htmlFor="facebook-page"
                                className="relative w-fit mt-[-0.70px] [font-family:'Poppins',Helvetica] font-normal text-white text-sm tracking-[0] leading-[18.2px] whitespace-nowrap"
                              >
                                Select your Facebook Page
                              </label>

                              <div className="relative self-stretch w-full facebook-page-dropdown">
                                <div
                                  className={`flex h-[38.5px] items-center justify-between px-[11.2px] py-[4.2px] relative self-stretch w-full bg-white rounded-[8.4px] overflow-hidden cursor-pointer hover:opacity-90 transition-opacity ${!pagesData?.pages || pagesData.pages.length === 0 ? 'cursor-default' : ''}`}
                                  onClick={() => !isPagesLoading && pagesData?.pages && pagesData.pages.length > 0 && setIsPageDropdownOpen(!isPageDropdownOpen)}
                                >
                                  <div className="inline-flex items-center gap-[8.4px] relative flex-[0_0_auto]">
                                    {!isPagesLoading && (
                                      <div className="relative w-[19.6px] h-[19.6px] bg-[#0202021a] rounded-[700px] overflow-hidden flex items-center justify-center">
                                        {(() => {
                                          const imageUrl = (selectedPage as any)?.picture?.data?.url;
                                          return imageUrl ? (
                                            <img
                                              className="w-full h-full object-cover"
                                              alt={selectedPage?.name || 'Selected page'}
                                              src={imageUrl}
                                            />
                                          ) : (
                                            <img
                                              className="absolute top-[5px] left-[3px] w-3 h-3 aspect-[0.98]"
                                              alt=""
                                              src=''
                                            />
                                          );
                                        })()}
                                      </div>
                                    )}

                                    <span className="relative w-fit [font-family:'Poppins',Helvetica] font-medium text-variable-collection-black text-[11.2px] tracking-[0] leading-[normal]">
                                      {isPagesLoading
                                        ? 'Loading...'
                                        : selectedPage
                                          ? selectedPage.name
                                          : (pagesData?.pages && pagesData.pages.length > 0 ? 'No pages found' : 'No Account Found')}
                                    </span>
                                  </div>

                                  {pagesData?.pages && pagesData.pages.length > 0 && !isPagesLoading && (
                                    <img
                                      className={`relative w-[22.4px] h-[22.4px] aspect-[1] transition-transform ${isPageDropdownOpen ? 'rotate-180' : ''}`}
                                      alt=""
                                      src={agnleDownSmall}
                                    />
                                  )}
                                </div>

                                {isPageDropdownOpen && pagesData?.pages && pagesData.pages.length > 0 && (
                                  <div className="absolute top-full left-0 right-0 mt-1 bg-white rounded-[8.4px] shadow-lg z-10 max-h-[200px] overflow-y-auto">
                                    {pagesData.pages.map((page) => (
                                      <div
                                        key={page.id}
                                        className={`flex items-center gap-[8.4px] px-[11.2px] py-[8px] cursor-pointer hover:bg-gray-100 ${selectedPage?.id === page.id ? 'bg-gray-100' : ''
                                          }`}
                                        onClick={() => {
                                          setSelectedPage(page);
                                          setIsPageDropdownOpen(false);
                                          // Reset ad account, pixel and Instagram account when page changes
                                          setSelectedAdAccount(null);
                                          setSelectedPixel(null);
                                          setSelectedInstagramAccount(null);
                                          // Persist selections (without ad account, pixel and Instagram)
                                          persistSelections(page, null, null, null);
                                        }}
                                      >
                                        <div className="relative w-[19.6px] h-[19.6px] bg-[#0202021a] rounded-[700px] overflow-hidden flex items-center justify-center">
                                          {(() => {
                                            const imageUrl = (page as any)?.picture?.data?.url;
                                            return imageUrl ? (
                                              <img
                                                className="w-full h-full object-cover"
                                                alt={page.name}
                                                src={imageUrl}
                                              />
                                            ) : (
                                              <img
                                                className="absolute top-[5px] left-[3px] w-3 h-3 aspect-[0.98]"
                                                alt=""
                                                src={rectangle5}
                                              />
                                            );
                                          })()}
                                        </div>
                                        <span className="relative w-fit [font-family:'Poppins',Helvetica] font-medium text-variable-collection-black text-[11.2px] tracking-[0] leading-[normal]">
                                          {page.name}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>

                              <p className="relative self-stretch [font-family:'Poppins',Helvetica] font-normal text-[#878da1] text-[9.8px] tracking-[0] leading-[12.7px]">
                                Select the Page you want to run ads from
                              </p>
                            </div>

                            <div className="flex flex-col w-[418.25px] items-start gap-[8.4px] pt-[11.2px] pb-0 px-0 relative mr-[-0.90px]">

                              {/* BUTTON RIGHT ALIGN */}
                              <div className="w-full flex justify-end">
                                <button
                                  onClick={handleDisconnectProfile}
                                  disabled={isDisconnecting}
                                  className="mb-4 inline-flex items-center gap-2
        [font-family:'Poppins',Helvetica] font-normal text-[#E2425C]
        text-[14px] leading-[130%] whitespace-nowrap
        hover:opacity-80 transition-opacity
        disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                  {isDisconnecting && (
                                    <CircularProgress size={14} style={{ color: "#ffffff" }} />
                                  )}
                                  <span>{isDisconnecting ? 'Disconnecting...' : 'Disconnect Profile'}</span>
                                  <img src={disconnectIcon} alt="Disconnect" className="w-5 h-5" />
                                </button>
                              </div>

                              <label
                                htmlFor="ad-account"
                                className="relative w-fit mt-[-0.70px] [font-family:'Poppins',Helvetica] font-normal text-white text-sm tracking-[0] leading-[18.2px] whitespace-nowrap"
                              >
                                Choose your Ad Account
                              </label>

                              <div className="relative self-stretch w-full ad-account-dropdown">
                                <div
                                  className={`flex h-[38.5px] items-center justify-between px-[11.2px] py-[4.2px] relative self-stretch w-full bg-white rounded-[8.4px] overflow-hidden cursor-pointer hover:opacity-90 transition-opacity ${!adAccountsData?.adAccounts || adAccountsData.adAccounts.length === 0 ? 'cursor-default' : ''}`}
                                  onClick={() => !isAdAccountsLoading && adAccountsData?.adAccounts && adAccountsData.adAccounts.length > 0 && setIsAdAccountDropdownOpen(!isAdAccountDropdownOpen)}
                                >
                                  <div className="inline-flex items-center relative flex-[0_0_auto]">
                                    <span className="relative w-fit [font-family:'Poppins',Helvetica] font-medium text-variable-collection-black text-[11.2px] tracking-[0] leading-[normal]">
                                      {isAdAccountsLoading
                                        ? 'Loading...'
                                        : selectedAdAccount
                                          ? (() => {
                                            const displayAccountId = selectedAdAccount.account_id || selectedAdAccount.id;
                                            return displayAccountId ? `${selectedAdAccount.name} [${displayAccountId}]` : selectedAdAccount.name;
                                          })()
                                          : (adAccountsData?.adAccounts && adAccountsData.adAccounts.length > 0
                                            ? 'Select an ad account'
                                            : 'No accounts found')
                                          }
                                    </span>
                                  </div>

                                  {adAccountsData?.adAccounts && adAccountsData.adAccounts.length > 0 && !isAdAccountsLoading && (
                                    <img
                                      className={`relative w-[22.4px] h-[22.4px] aspect-[1] transition-transform ${isAdAccountDropdownOpen ? 'rotate-180' : ''}`}
                                      alt=""
                                      src={agnleDownSmall}
                                    />
                                  )}
                                </div>

                                {isAdAccountDropdownOpen && adAccountsData?.adAccounts && adAccountsData.adAccounts.length > 0 && (
                                  <div className="absolute top-full left-0 right-0 mt-1 bg-white rounded-[8.4px] shadow-lg z-10 max-h-[200px] overflow-y-auto">
                                    {adAccountsData.adAccounts.map((account) => (
                                      <div
                                        key={account.id}
                                        className={`flex items-center px-[11.2px] py-[8px] cursor-pointer hover:bg-gray-100 ${selectedAdAccount?.id === account.id ? 'bg-gray-100' : ''
                                          }`}
                                        onClick={() => {
                                          setSelectedAdAccount(account);
                                          setIsAdAccountDropdownOpen(false);
                                          // Immediately persist to sessionStorage
                                          persistSelections(selectedPage, account, selectedInstagramAccount, selectedPixel);
                                        }}
                                      >
                                        <span className="relative w-fit [font-family:'Poppins',Helvetica] font-medium text-variable-collection-black text-[11.2px] tracking-[0] leading-[normal]">
                                          {(() => {
                                            const displayAccountId = account.account_id || account.id;
                                            return displayAccountId ? `${account.name} [${displayAccountId}]` : account.name;
                                          })()}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>

                              <p className="relative self-stretch [font-family:'Poppins',Helvetica] font-normal text-[#878da1] text-[9.8px] tracking-[0] leading-[12.7px]">
                                Make sure it has permissions to your Page
                              </p>
                            </div>
                          </div>

                          <div className="flex w-full lg:w-5/6 items-start gap-[8.4px] pl-[30px] pr-0 py-0 relative flex-[0_0_auto]">
                            <div className="w-[418.25px] flex flex-col items-start gap-[8.4px] pl-[30.8px] pr-0 pt-[11.2px] pb-0 relative">
                              <label
                                htmlFor="instagram-account"
                                className="relative w-fit mt-[-0.70px] [font-family:'Poppins',Helvetica] font-normal text-white text-sm tracking-[0] leading-[18.2px] whitespace-nowrap"
                              >
                                Select Instagram Account
                              </label>

                              <div className="relative self-stretch w-full instagram-account-dropdown">
                                <div
                                  className={`flex h-[38.5px] items-center justify-between px-[11.2px] py-[4.2px] relative self-stretch w-full bg-white rounded-[8.4px] overflow-hidden cursor-pointer hover:opacity-90 transition-opacity ${(() => { const accounts = instagramAccountsData?.instagramAccounts || instagramAccountsData?.accounts || instagramAccountsData?.instagram_accounts; return (!accounts || accounts.length === 0 || isInstagramAccountsError) ? 'cursor-default' : ''; })()}`}
                                  onClick={() => {
                                    const accounts = instagramAccountsData?.instagramAccounts || instagramAccountsData?.accounts || instagramAccountsData?.instagram_accounts;
                                    if (!isInstagramAccountsLoading && !isRetryingInstagram && !isInstagramAccountsError && accounts && accounts.length > 0) {
                                      setIsInstagramDropdownOpen(!isInstagramDropdownOpen);
                                    }
                                  }}
                                >
                                  <div className="inline-flex items-center gap-[8.4px] relative flex-[0_0_auto]">
                                    {!isInstagramAccountsLoading && (() => {
                                      const accounts = instagramAccountsData?.instagramAccounts || instagramAccountsData?.accounts || instagramAccountsData?.instagram_accounts;
                                      const hasAccounts = accounts && accounts.length > 0;
                                      const showIcon = selectedInstagramAccount;

                                      return showIcon ? (
                                        <div className="relative w-[19.6px] h-[19.6px] bg-[#0202021a] rounded-[700px] overflow-hidden flex items-center justify-center">
                                          {selectedInstagramAccount?.profile_picture_url ? (
                                            <img
                                              className="w-full h-full object-cover"
                                              alt={selectedInstagramAccount.name}
                                              src={selectedInstagramAccount.profile_picture_url}
                                            />
                                          ) : (
                                            <img
                                              className="absolute top-[5px] left-[3px] w-3 h-3 aspect-[0.98]"
                                              alt=""
                                              src={rectangle5}
                                            />
                                          )}
                                        </div>
                                      ) : null;
                                    })()}

                                    <span className="relative w-fit [font-family:'Poppins',Helvetica] font-medium text-variable-collection-black text-[11.2px] tracking-[0] leading-[normal]">
                                      {isInstagramAccountsLoading || isRetryingInstagram
                                        ? 'Loading...'
                                        : selectedInstagramAccount
                                          ? selectedInstagramAccount.name
                                          : (() => {
                                            const accounts = instagramAccountsData?.instagramAccounts || instagramAccountsData?.accounts || instagramAccountsData?.instagram_accounts;
                                            if (isInstagramAccountsError) {
                                              return 'Failed to load';
                                            }
                                            return accounts && accounts.length > 0 ? 'Select Account' : 'No accounts found';
                                          })()}
                                    </span>
                                  </div>

                                  {(() => {
                                    const accounts = instagramAccountsData?.instagramAccounts || instagramAccountsData?.accounts || instagramAccountsData?.instagram_accounts;
                                    return accounts && accounts.length > 0 && !isInstagramAccountsLoading && !isRetryingInstagram ? (
                                      <img
                                        className={`relative w-[22.4px] h-[22.4px] aspect-[1] transition-transform ${isInstagramDropdownOpen ? 'rotate-180' : ''}`}
                                        alt=""
                                        src={agnleDownSmall}
                                      />
                                    ) : null;
                                  })()}
                                </div>

                                {isInstagramDropdownOpen && (() => {
                                  const accounts = instagramAccountsData?.instagramAccounts || instagramAccountsData?.accounts || instagramAccountsData?.instagram_accounts;
                                  return accounts && accounts.length > 0 && (
                                    <div className="absolute top-full left-0 right-0 mt-1 bg-white rounded-[8.4px] shadow-lg z-10 max-h-[200px] overflow-y-auto">
                                      {accounts.map((account) => {
                                        const displayName = account.username || account.pageName || account.name || 'Instagram Account';
                                        return (
                                          <div
                                            key={account.id}
                                            className={`flex items-center gap-[8.4px] px-[11.2px] py-[8px] cursor-pointer hover:bg-gray-100 ${selectedInstagramAccount?.id === account.id ? 'bg-gray-100' : ''
                                              }`}
                                            onClick={() => {
                                              const updatedInstagramAccount = {
                                                id: account.id,
                                                name: displayName,
                                                profile_picture_url: account.profile_picture_url
                                              };
                                              setSelectedInstagramAccount(updatedInstagramAccount);
                                              setIsInstagramDropdownOpen(false);
                                              // Immediately persist to sessionStorage
                                              persistSelections(selectedPage, selectedAdAccount, updatedInstagramAccount, selectedPixel);
                                            }}
                                          >
                                            <div className="relative w-[19.6px] h-[19.6px] bg-[#0202021a] rounded-[700px] overflow-hidden flex items-center justify-center">
                                              {account.profile_picture_url ? (
                                                <img
                                                  className="w-full h-full object-cover"
                                                  alt={displayName}
                                                  src={account.profile_picture_url}
                                                />
                                              ) : (
                                                <img
                                                  className="absolute top-[5px] left-[3px] w-3 h-3 aspect-[0.98]"
                                                  alt=""
                                                  src={rectangle5}
                                                />
                                              )}
                                            </div>
                                            <span className="relative w-fit [font-family:'Poppins',Helvetica] font-medium text-variable-collection-black text-[11.2px] tracking-[0] leading-[normal]">
                                              {displayName}
                                            </span>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  );
                                })()}
                              </div>

                              <p className="relative self-stretch [font-family:'Poppins',Helvetica] font-normal text-[#878da1] text-[9.8px] tracking-[0] leading-[12.7px]">
                                Linked to your Facebook Business Manager
                              </p>
                            </div>

                            <div className="w-[418.25px] flex flex-col items-start gap-[8.4px] pt-[11.2px] pb-0 px-0 relative">
                              <label
                                htmlFor="pixel"
                                className={`relative w-fit mt-[-0.70px] [font-family:'Poppins',Helvetica] font-normal text-sm tracking-[0] leading-[18.2px] whitespace-nowrap ${!selectedAdAccount ? "text-[#878da1]" : "text-white"}`}
                              >
                                Choose or connect a Pixel
                              </label>

                              <div className="relative self-stretch w-full pixel-dropdown">
                                <div
                                  className={`flex h-[38.5px] items-center justify-between px-[11.2px] py-[4.2px] relative self-stretch w-full rounded-[8.4px] overflow-hidden transition-all ${
                                    !selectedAdAccount
                                      ? "bg-[#b3b3b3] border border-transparent cursor-not-allowed select-none"
                                      : "bg-white cursor-pointer hover:opacity-90 border-transparent"
                                  } ${!pixelsData?.pixels || pixelsData.pixels.length === 0 ? 'cursor-default' : ''}`}
                                  onClick={() => selectedAdAccount && !isPixelsLoading && pixelsData?.pixels && pixelsData.pixels.length > 0 && setIsPixelDropdownOpen(!isPixelDropdownOpen)}
                                >
                                  <div className="inline-flex items-center relative flex-[0_0_auto]">
                                    <span className={`relative w-fit [font-family:'Poppins',Helvetica] font-medium text-[11.2px] tracking-[0] leading-[normal] ${
                                      !selectedAdAccount ? "text-[#0b0b0b]" : "text-variable-collection-black"
                                    }`}>
                                      {isPixelsLoading
                                        ? 'Loading...'
                                        : !selectedAdAccount
                                          ? 'Select an ad account first'
                                          : selectedPixel
                                            ? `${selectedPixel.name}${selectedPixel.id ? ` [${selectedPixel.id}]` : ''}`
                                            : (pixelsData?.pixels && pixelsData.pixels.length > 0 ? 'Select a pixel' : 'No Pixel Found')}
                                    </span>
                                  </div>

                                  {pixelsData?.pixels && pixelsData.pixels.length > 0 && !isPixelsLoading && (
                                    <img
                                      className={`relative w-[22.4px] h-[22.4px] aspect-[1] transition-transform ${isPixelDropdownOpen ? 'rotate-180' : ''}`}
                                      alt=""
                                      src={agnleDownSmall}
                                    />
                                  )}
                                </div>

                                {isPixelDropdownOpen && pixelsData?.pixels && pixelsData.pixels.length > 0 && (
                                  <div className="absolute top-full left-0 right-0 mt-1 bg-white rounded-[8.4px] shadow-lg z-10 max-h-[200px] overflow-y-auto">
                                    {pixelsData.pixels.map((pixel) => (
                                      <div
                                        key={pixel.id}
                                        className={`flex items-center px-[11.2px] py-[8px] cursor-pointer hover:bg-gray-100 ${selectedPixel?.id === pixel.id ? 'bg-gray-100' : ''
                                          }`}
                                        onClick={() => {
                                          setSelectedPixel(pixel);
                                          setIsPixelDropdownOpen(false);
                                          // Immediately persist to sessionStorage
                                          persistSelections(selectedPage, selectedAdAccount, selectedInstagramAccount, pixel);
                                        }}
                                      >
                                        <span className="relative w-fit [font-family:'Poppins',Helvetica] font-medium text-variable-collection-black text-[11.2px] tracking-[0] leading-[normal]">
                                          {`${pixel.name}${pixel.id ? ` [${pixel.id}]` : ''}`}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>

                              <p className="relative self-stretch [font-family:'Poppins',Helvetica] font-normal text-transparent text-[9.8px] tracking-[0] leading-[12.7px]">
                                <span className="text-[#878da1]">Select a pixel, and  </span>
                                <span className="text-white">make sure to add it in Step 3</span>
                                <span className="text-[#878da1]"> to enable smart link tracking</span>
                              </p>
                            </div>
                          </div>
                        </>
                      )}
                    </section>

                    {isFacebookConnected && (
                      <>
                        <img
                          className="relative w-full h-px object-cover"
                          alt=""
                          src={line53}
                        />

                        <section className="flex flex-col items-start gap-2.5 relative self-stretch w-full flex-[0_0_auto] z-10">
                          <div className="flex flex-col items-start gap-8 relative self-stretch w-full flex-[0_0_auto]">
                            <div className="inline-flex items-center gap-6 relative flex-[0_0_auto]">
                              <div className="w-10 h-10 flex items-center justify-center relative z-10">
                                <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center overflow-hidden">
                                  <img
                                    src={metaStep3}
                                    alt="Step 3"
                                    className="w-full h-full object-contain"
                                  />
                                </div>
                              </div>


                              <div className="flex flex-col w-full lg:w-11/12 items-start gap-6 relative z-10">
                                <h2 className="mt-[-1.00px] opacity-[0.88] font-semibold text-[38px] leading-10 relative w-fit [font-family:'Poppins',Helvetica] text-white tracking-[0] whitespace-nowrap">
                                  Pixel Setup
                                </h2>
                              </div>

                            </div>

                            <div className="inline-flex flex-col items-start gap-2.5 relative flex-[0_0_auto] mr-[-35.00px]">
                              <div className="inline-flex items-center justify-center gap-2.5 pl-[60px] pr-0 py-0 relative flex-[0_0_auto]">
                                <p className="relative w-[1109px] mt-[-1.00px] opacity-70 [font-family:'Poppins',Helvetica] font-normal text-white text-sm tracking-[0] leading-[19.6px]">
                                  Add all tracking pixels from your Ad account(s) to use
                                  with ad gates and smart links.
                                  <br />
                                  In Step 2, we&apos;ll make sure to provide the pixels
                                  connected to your ad account.
                                </p>
                              </div>

                            </div>

                            {/* Display saved pixels list */}
                            {savedPixelsData?.pixels && savedPixelsData.pixels.length > 0 && (
                              <div className="flex flex-col w-[1242px] items-start gap-[8.4px] pl-[30px] pr-0 py-0 mt-4 relative flex-[0_0_auto] mt-[-20px]">
                                {savedPixelsData.pixels.map((pixel, index) => (
                                  <div key={pixel.id || index} className="flex items-start gap-[8.4px] w-full">
                                    {/* Pixel Name */}
                                    <div className="w-[212px] flex flex-col items-start gap-[8.4px] pl-[30.8px] pr-0 pt-[11.2px] pb-0 relative">
                                      <input
                                        type="text"
                                        value={editablePixelIndex === index && editingPixelData ? editingPixelData.name : (pixel.name || '')}
                                        readOnly={editablePixelIndex !== index}
                                        onChange={(e) => editablePixelIndex === index && handleEditPixelFieldChange('name', e.target.value)}
                                        className={`h-[38.5px] px-[11.2px] py-[4.2px] self-stretch w-full flex items-center relative rounded-[8.4px] overflow-hidden border focus:outline-none text-[11.2px] [font-family:'Poppins',Helvetica] font-medium text-center ${editablePixelIndex === index
                                          ? 'bg-white border-gray-300 text-black focus:border-green-500'
                                          : 'bg-[#b3b3b3] border-transparent text-[#0b0b0b] cursor-not-allowed select-none'
                                          }`}
                                      />
                                      <p className="relative self-stretch [font-family:'Poppins',Helvetica] font-normal text-[#878da1] text-[9.8px] text-center tracking-[0] leading-[12.7px]">
                                        Pixel name
                                      </p>
                                    </div>

                                    {/* Pixel Type - Always non-editable */}
                                    <div className="flex flex-col w-[250px] items-start gap-[8.4px] pt-[11.2px] pb-0 px-0 relative">
                                      <input
                                        type="text"
                                        value={editablePixelIndex === index && editingPixelData ? editingPixelData.type : ('Facebook Ads [Pixel + CAPI Token]')}
                                        readOnly={true}
                                        className="w-[250px] h-[39px] px-[11.2px] py-[4.2px] flex items-center relative rounded-[8.4px] overflow-hidden border border-transparent focus:outline-none text-[11.2px] [font-family:'Poppins',Helvetica] font-medium text-center bg-[#b3b3b3] text-[#0b0b0b] cursor-not-allowed select-none"
                                        style={{ textAlign: "center" }}
                                      />
                                      <p className="relative self-stretch [font-family:'Poppins',Helvetica] font-normal text-[#878da1] text-[9.8px] text-center tracking-[0] leading-[12.7px]">
                                        Pixel type
                                      </p>
                                    </div>

                                    {/* Pixel ID */}
                                    <div className="flex flex-col w-[174px] items-start gap-[8.4px] pt-[11.2px] pb-0 px-0 relative">
                                      <input
                                        type="text"
                                        value={editablePixelIndex === index && editingPixelData ? editingPixelData.id : (pixel.id || pixel.pixelId || '')}
                                        readOnly={editablePixelIndex !== index}
                                        onChange={(e) => editablePixelIndex === index && handleEditPixelFieldChange('id', e.target.value)}
                                        className={`w-[174px] h-[39px] px-[11.2px] py-[4.2px] flex items-center relative rounded-[8.4px] overflow-hidden border focus:outline-none text-[11.2px] [font-family:'Poppins',Helvetica] font-medium text-center ${editablePixelIndex === index
                                          ? 'bg-white border-gray-300 text-black focus:border-green-500'
                                          : 'bg-[#b3b3b3] border-transparent text-[#0b0b0b] cursor-not-allowed select-none'
                                          }`}
                                      />
                                      <p className="relative self-stretch [font-family:'Poppins',Helvetica] font-normal text-[#878da1] text-[9.8px] text-center tracking-[0] leading-[12.7px]">
                                        Pixel ID
                                      </p>
                                    </div>

                                    {/* CAPI Token - Show if it has a value, or always show in edit mode */}
                                    {(() => {
                                      const capiTokenValue = editablePixelIndex === index && editingPixelData
                                        ? editingPixelData.capiToken
                                        : (pixel as any).capiToken;
                                      const hasValue = capiTokenValue && capiTokenValue.trim();
                                      const isEditing = editablePixelIndex === index;

                                      // Always show in edit mode, or show if it has a value when not editing
                                      if (isEditing || hasValue) {
                                        return (
                                          <div className="flex flex-col w-[274px] items-start gap-[8.4px] pt-[11.2px] pb-0 px-0 relative">
                                            <input
                                              type="text"
                                              value={capiTokenValue || ''}
                                              readOnly={!isEditing}
                                              onChange={(e) => isEditing && handleEditPixelFieldChange('capiToken', e.target.value)}
                                              placeholder="Facebook Ads Conversion API (CAPI) Access Token"
                                              className={`w-[274px] h-[39px] px-[11.2px] py-[4.2px] flex items-center relative rounded-[8.4px] overflow-hidden border focus:outline-none text-[11.2px] [font-family:'Poppins',Helvetica] font-medium text-center ${isEditing
                                                ? 'bg-white border-gray-300 text-black focus:border-green-500'
                                                : 'bg-[#b3b3b3] border-transparent text-[#0b0b0b] cursor-not-allowed select-none'
                                                }`}
                                            />
                                            <p className="relative [font-family:'Poppins',Helvetica] font-normal text-[#878da1] text-[9.8px] tracking-[0] leading-[12.7px] w-[290px] text-left">
                                              (For better performance) Enter the Facebook Ads conversion api (CAPI) access
                                              token linked with the Facebook Ads pixel ID entered above (optional)
                                            </p>
                                          </div>
                                        );
                                      }
                                      return null;
                                    })()}

                                    {/* Action buttons - Show checkmark/cancel when editing, otherwise show more options */}
                                    {editablePixelIndex === index ? (
                                      <div className="flex flex-col w-[100px] items-center gap-[8.4px] pt-[11.2px] pb-0 px-0 relative ml-2 mb-5">
                                        <div className="w-[100px] h-[39px] flex items-center justify-center gap-3 px-[11.2px] py-[4.2px] bg-transparent overflow-hidden">
                                          {/* Tick Icon - Save */}
                                          {isUpdatingPixel ? (
                                            <CircularProgress size={20} style={{ color: "#58f2a9" }} />
                                          ) : (
                                            <img
                                              src={tickIcon}
                                              alt="Save pixel"
                                              onClick={handleSaveEditPixel}
                                              className="w-7 h-7 cursor-pointer hover:opacity-80 transition-opacity"
                                              title="Save pixel"
                                            />
                                          )}

                                          {/* Cancel Icon - Cancel */}
                                          <img
                                            src={cancelIcon}
                                            alt="Cancel"
                                            onClick={handleCancelEditPixel}
                                            className={`w-7 h-7 transition-opacity ${isUpdatingPixel ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:opacity-80'}`}
                                            title="Cancel"
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        className="relative flex items-center h-[50px] pt-[8.8px] pb-0 px-0"
                                        data-pixel-menu-index={index}
                                        style={{ width: "32px" }}
                                      >
                                        <button
                                          aria-label="More options"
                                          data-pixel-menu-index={index}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setPixelOptionsOpenIndex(prev => prev === index ? null : index);
                                          }}
                                        >
                                          <img
                                            className="relative w-[22.4px] h-[22.4px] aspect-[1]"
                                            alt=""
                                            src={moreCircle}
                                          />
                                        </button>
                                        {pixelOptionsOpenIndex === index && (
                                          <div
                                            data-pixel-menu-index={index}
                                            className="absolute z-20 min-w-[140px] ml-[70px] mb-[-10px] rounded-2xl bg-[#1b1c20] border border-[#2c2f36] shadow-[0_8px_24px_rgba(0,0,0,0.45)] px-4 py-3 flex flex-col gap-3 text-white text-base"
                                            style={{
                                              bottom: 'calc(100% + 10px)',
                                              left: '50%',
                                              transform: 'translateX(-50%)'
                                            }}
                                          >
                                            <button
                                              className="text-left hover:opacity-80"
                                              onClick={() => handleEditPixel(index)}
                                            >
                                              Edit
                                            </button>
                                            <div className="h-px bg-[#2c2f36]" />
                                            <button
                                              className={`text-left ${isDeletingPixel ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-80'}`}
                                              onClick={() => handleRemovePixel(index)}
                                              disabled={isDeletingPixel}
                                            >
                                              {isDeletingPixel ? 'Removing...' : 'Remove'}
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}

                            {/* New 4-field pixel input form */}
                            {showNewPixelForm && (
                              <div className="flex w-[1242px] items-start gap-[8.4px] pl-[30px] pr-0 py-0 mt-4 relative flex-[0_0_auto] mt-[-30px]">
                                {/* Field 1: Pixel Name */}
                                <div className="w-[212px] flex flex-col items-start gap-[8.4px] pl-[30.8px] pr-0 pt-[11.2px] pb-0 relative">
                                  <input
                                    type="text"
                                    value={newPixelData.name}
                                    onChange={(e) => handleNewPixelInputChange('name', e.target.value)}
                                    placeholder="Enter pixel name"
                                    className="h-[38.5px] px-[11.2px] py-[4.2px] self-stretch w-full flex items-center relative bg-white rounded-[8.4px] overflow-hidden border border-gray-300 focus:border-green-500 focus:outline-none text-black text-[11.2px] placeholder-gray-400 text-center placeholder:text-center"
                                  />
                                  <p className="relative self-stretch [font-family:'Poppins',Helvetica] font-normal text-[#878da1] text-[9.8px] text-center tracking-[0] leading-[12.7px]">
                                    Pixel name
                                  </p>
                                </div>

                                {/* Field 2: Pixel Type */}
                                <div className="flex flex-col w-[250px] items-start gap-[8.4px] pt-[11.2px] pb-0 px-0 relative">
                                  <input
                                    type="text"
                                    readOnly
                                    aria-readonly="true"
                                    placeholder="Facebook Ads [Pixel + CAPI Token]"
                                    className="w-[250px] h-[39px] px-[11.2px] py-[4.2px] flex items-center relative bg-[#b3b3b3] rounded-[8.4px] overflow-hidden border border-transparent focus:outline-none text-[#0b0b0b] text-[11.2px] [font-family:'Poppins',Helvetica] font-medium cursor-not-allowed select-none placeholder-[#0b0b0b] text-center"
                                    style={{ textAlign: "center" }}
                                  />
                                  <p className="relative self-stretch [font-family:'Poppins',Helvetica] font-normal text-[#878da1] text-[9.8px] text-center tracking-[0] leading-[12.7px]">
                                    Pixel type
                                  </p>
                                </div>

                                {/* Field 3: Pixel ID */}
                                <div className="flex flex-col w-[174px] items-start gap-[8.4px] pt-[11.2px] pb-0 px-0 relative">
                                  <input
                                    type="text"
                                    value={newPixelData.id}
                                    onChange={(e) => handleNewPixelInputChange('id', e.target.value)}
                                    placeholder="Enter pixel ID"
                                    className="w-[174px] h-[39px] px-[11.2px] py-[4.2px] flex items-center relative bg-white rounded-[8.4px] overflow-hidden border border-gray-300 focus:border-green-500 focus:outline-none text-black text-[11.2px] placeholder-gray-400 text-center placeholder:text-center"
                                  />
                                  <p className="relative self-stretch [font-family:'Poppins',Helvetica] font-normal text-[#878da1] text-[9.8px] text-center tracking-[0] leading-[12.7px]">
                                    Pixel ID
                                  </p>
                                </div>

                                {/* Field 4: CAPI Token */}
                                <div className="flex flex-col w-[274px] items-start gap-[8.4px] pt-[11.2px] pb-0 px-0 relative">
                                  <input
                                    type="text"
                                    value={newPixelData.capiToken || ''}
                                    onChange={(e) => handleNewPixelInputChange('capiToken', e.target.value)}
                                    placeholder="Facebook Ads Conversion API (CAPI) Access Token"
                                    className="w-[274px] h-[39px] px-[11.2px] py-[4.2px] flex items-center relative bg-white rounded-[8.4px] overflow-hidden border border-gray-300 focus:border-green-500 focus:outline-none text-black text-[11.2px] placeholder-gray-400 text-center placeholder:text-center"
                                  />
                                  <p className="relative [font-family:'Poppins',Helvetica] font-normal text-[#878da1] text-[9.8px] tracking-[0] leading-[12.7px] w-[290px] text-left">
                                    (For better performance) Enter the Facebook Ads conversion api (CAPI) access
                                    token linked with the                            Facebook Ads pixel ID entered above (optional)
                                  </p>
                                </div>

                                {/* Action Icons */}
                                <div className="flex flex-col w-[100px] items-center gap-[8.4px] pt-[11.2px] pb-0 px-0 relative ml-2">
                                  <div className="w-[100px] h-[39px] flex items-center justify-center gap-3 px-[11.2px] py-[4.2px] bg-transparent overflow-hidden">
                                    {/* Tick Icon - Save */}
                                    {isCreatingPixel ? (
                                      <CircularProgress size={20} style={{ color: "#58f2a9" }} />
                                    ) : (
                                      <img
                                        src={tickIcon}
                                        alt="Save pixel"
                                        onClick={handleSaveNewPixel}
                                        className="w-7 h-7 cursor-pointer hover:opacity-80 transition-opacity"
                                        title="Save pixel"
                                      />
                                    )}

                                    {/* Cancel Icon - Cancel */}
                                    <img
                                      src={cancelIcon}
                                      alt="Cancel"
                                      onClick={isCreatingPixel ? undefined : handleCancelNewPixel}
                                      className={`w-7 h-7 transition-opacity ${isCreatingPixel ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:opacity-80'}`}
                                      title="Cancel"
                                    />
                                  </div>
                                </div>

                              </div>
                            )}
                          </div>

                          <div className="flex flex-col w-full items-start justify-center gap-2.5 relative flex-[0_0_auto]">
                            <div className="flex items-center justify-between pl-[60px] pr-0 py-0 w-full">

                              {!showNewPixelForm && editablePixelIndex === null && (
                                <button
                                  className="inline-flex items-center gap-2 font-normal text-[#58f2a9] text-sm leading-[19.6px] [font-family:'Poppins',Helvetica]"
                                  onClick={handleAddNewPixel}
                                >
                                  Add New Pixel
                                  <img
                                    src={plusIcon}
                                    alt="Add new pixel"
                                    className="w-4 h-4"
                                  />
                                </button>
                              )}

                              <div className="flex-1"></div>

                              <button
                                className="inline-flex items-center gap-2 font-normal text-[#58F2A9] text-sm leading-[18.2px] [font-family:'Poppins',Helvetica]"
                                onClick={() => setShowFullGuide(!showFullGuide)}
                              >
                                {showFullGuide ? 'Hide full guide' : 'Show full guide'}
                                {showFullGuide ? (
                                  <svg
                                    className="w-4 h-3 color-[#58F2A9]"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M5 15l7-7 7 7"
                                      stroke="#58F2A9"
                                    />
                                  </svg>
                                ) : (
                                  <svg
                                    className="w-3 h-3"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M19 9l-7 7-7-7"
                                      stroke="#58F2A9"
                                    />
                                  </svg>
                                )}
                              </button>

                            </div>
                          </div>

                          {showFullGuide && (
                            <div className="mt-6">
                              {setupSteps.map((step, index) => (
                                <article
                                  key={step.number}
                                  className={`flex flex-col items-end justify-center gap-3 pl-[60px] pr-0 relative self-stretch w-full flex-[0_0_auto] ${index === setupSteps.length - 1 ? 'pt-6 pb-0' : 'py-6'
                                    }`}
                                >
                                  <div className="flex items-center gap-3 relative self-stretch w-full flex-[0_0_auto]">
                                    <div className="w-8 h-8 bg-variable-collection-green2 rounded-[10000px] flex items-center justify-center" style={{ width: "34px", height: "32px", transform: "rotate(0deg)", opacity: 1, borderRadius: "10000px" }}>
                                      <span className="font-medium text-xl text-black text-variable-collection-black leading-none">
                                        {step.number}
                                      </span>
                                    </div>

                                    <p className="font-normal text-xl text-center leading-[26.0px] relative w-fit [font-family:'Poppins',Helvetica] text-variable-collection-white tracking-[0] whitespace-nowrap">
                                      {step.title}
                                    </p>
                                  </div>

                                  <div className="flex items-start gap-4 relative self-stretch w-full flex-[0_0_auto]">
                                    <div className="flex flex-col items-start gap-6 p-6 relative flex-1 self-stretch grow bg-[#878da11a] rounded-[20px]">
                                      <div className="flex flex-col items-start gap-3 relative self-stretch w-full flex-[0_0_auto]">
                                        <p className="relative self-stretch mt-[-1.00px] [font-family:'Poppins',Helvetica] font-medium text-white text-lg tracking-[0] leading-[25.2px]">
                                          {step.content.heading}
                                        </p>

                                        {step.content.hasImage && (
                                          <div className="relative w-[720px] h-[260px] bg-[#d9d9d9] rounded-2xl" />
                                        )}

                                        <p className="relative self-stretch opacity-70 [font-family:'Poppins',Helvetica] font-normal text-white text-sm tracking-[0] leading-[19.6px]">
                                          {step.content.description}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </article>
                              ))}
                            </div>
                          )}
                        </section>
                      </>
                    )}

                    <CollapsibleSections openHowItWorks={openHowItWorks} />

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}